















































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentEmitirRelatorioEmLote extends Vue {
  loadEmitirRelatorio: boolean = false

  get modalEmitirRelatorio() { return this.getFinanceiroStore.modal.emitirRelatorioEmLote }
  set modalEmitirRelatorio(value: boolean) { this.getFinanceiroStore.setModal({ name: 'emitirRelatorioEmLote', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get loadingEmitirRelatorio() {
    return this.loadEmitirRelatorio
  }

  set loadingEmitirRelatorio(value: boolean) {
    this.loadEmitirRelatorio = value
  }

  closeModalEmitirRelatorio() {
    this.getFinanceiroStore.clearGeracaoRepasses()
    this.modalEmitirRelatorio = false
  }

  async emitirRelatorio() {
    this.loadingEmitirRelatorio = true

    if (this.getFinanceiroStore.emitirRelatorioEmLote.length > 10) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'A quantidade limite de repasses é 10.',
        icon: 'warning',
        color: '#C62828'
      })
      this.closeModalEmitirRelatorio()
      this.loadingEmitirRelatorio = false
      return
    }

    const response = await this.getFinanceiroStore.emitirRelatoriosEmLote()

    if (response.success) {
      const link = document.createElement('a')
      link.href = response.data.ArquivoUrl
      link.download = response.data.NomeArquivo
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Relatórios emitidos com sucesso!',
        icon: 'done',
        color: '#2E7D32'
      })
      this.closeModalEmitirRelatorio()
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || 'Ocorreu um erro ao emitir os relatórios.',
        icon: 'warning',
        color: '#C62828'
      })
    }

    this.loadingEmitirRelatorio = false
  }
}
